import { createContext, useEffect, useState } from "react";

export const AppContext = createContext()

const AppContextProvider = ({ children }) => {

    const [loggedIn, setLoggedIn] = useState(true)
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        let loginSession = window.sessionStorage.getItem("tripstore_login")
        if (loginSession && loginSession === "true") {
            setLoggedIn(true)
        } else {
            setLoggedIn(false)
        }

        window.onscroll = () => {
            setOffset(window.scrollY)
        }
    }, [])

    return (
        <AppContext.Provider value={{ loggedIn, setLoggedIn, offset }}>
            {children}
        </AppContext.Provider>
    )
}

export default AppContextProvider